import {I18n} from '@lingui/core';
import {useLingui} from '@lingui/react';
import {ChargebackDetailsOutput} from '@zentact/api/src/trpc/routers/chargebackRouter';
import {formatLocaleDate} from '@zentact/common';
import {chargebackStatusToColor, getChargebackStatusMap} from '..';
import {FlatPillWithDot} from '../..';

export const getChargebackEventDisplayMap = (i18n: I18n): {[key: string]: string} => ({
  // biome-ignore lint/style/useNamingConvention: <explanation>
  NOTIFICATION_OF_FRAUD: i18n._('Notification Of Fraud'),
  // biome-ignore lint/style/useNamingConvention: <explanation>
  REQUEST_FOR_INFORMATION: i18n._('Request For Information'),
  // biome-ignore lint/style/useNamingConvention: <explanation>
  NOTIFICATION_OF_CHARGEBACK: i18n._('Notification of Chargeback'),
  // biome-ignore lint/style/useNamingConvention: <explanation>
  CHARGEBACK: i18n._('Chargeback'),
  // biome-ignore lint/style/useNamingConvention: <explanation>
  SECOND_CHARGEBACK: i18n._('Second Chargeback'),
  // biome-ignore lint/style/useNamingConvention: <explanation>
  CHARGEBACK_REVERSED: i18n._('Chargeback Reversed'),
  // biome-ignore lint/style/useNamingConvention: <explanation>
  PREARBITRATION_WON: i18n._('Dispute Won'),
  // biome-ignore lint/style/useNamingConvention: <explanation>
  PREARBITRATION_LOST: i18n._('Dispute Lost'),
  // biome-ignore lint/style/useNamingConvention: <explanation>
  DISPUTE_DEFENSE_PERIOD_ENDED: i18n._('Dispute Defense Period Ended'),
  // biome-ignore lint/style/useNamingConvention: <explanation>
  INFORMATION_SUPPLIED: i18n._('Information Supplied'),
  // biome-ignore lint/style/useNamingConvention: <explanation>
  ISSUER_RESPONSE_TIMEFRAME_EXPIRED: i18n._('Issuer Response Timeframe Expired'),
  // biome-ignore lint/style/useNamingConvention: <explanation>
  ISSUER_COMMENTS: i18n._('Issuer Comments'),
});

type Props = {
  chargeback: ChargebackDetailsOutput;
};

export const ChargebackEventsList = ({chargeback}: Props) => {
  const {i18n} = useLingui();
  return (
    <ul>
      {chargeback.chargebackEvents.map((event, i) => (
        <li key={`payment-${i}`} className="flex text-sm leading-6 ">
          <div className="flex flex-col items-center mr-5">
            <div className="mt-[2px] mb-[5px] h-[20px] w-[20px] rounded-full border-solid border-[2px] bg-white border-gray-200 shadow-sm" />
            {i < chargeback.chargebackEvents.length - 1 && (
              <div className="flex-1 w-[2px] bg-gray-200 mb-[3px]" />
            )}
          </div>
          <div className="grid w-full pb-5 md:grid-cols-[minmax(200px,_300px)_minmax(340px,_400px)_minmax(150px,_300px)_minmax(0,_1fr)]">
            <div className="flex md:col-span-1">
              <div className="font-medium text-gray-900 whitespace-nowrap">
                {getChargebackEventDisplayMap(i18n)[event.type] ?? event.type}
              </div>
            </div>
            <div className="text-gray-700 md:col-span-1">
              <div className="flex whitespace-nowrap gap-x-2">
                {i18n._('Status: ')}{' '}
                <FlatPillWithDot
                  color={chargebackStatusToColor[event.status] || 'blue'}
                  label={getChargebackStatusMap(i18n)[event.status] ?? status}
                />
              </div>
              {event.pspReferenceId && (
                <div className="whitespace-nowrap">
                  {i18n._('Reference: ')} {event.pspReferenceId}
                </div>
              )}
              {event.reason && (
                <div className="whitespace-nowrap">
                  {i18n._('Reason: ')} {event.reason}
                </div>
              )}
            </div>
            <div className="font-medium text-gray-400 md:text-right md:col-span-1 whitespace-nowrap">
              {formatLocaleDate(event.createdAt)}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};
